import { useMemo } from 'react';
import { useHideIntroVariant } from '../state/actions/useHideIntroVariant';
import { useInitialiseCanvas } from '../state/actions/useInitialiseCanvas';
import { useUpdateCanvas } from '../state/actions/useUpdateCanvas';
import { useHideIntroVariantSelector } from '../state/selectors/useHideIntroVariantSelector';

export const useCanvas = () => {
  const hideIntroVariant = useHideIntroVariant();
  const initialiseCanvas = useInitialiseCanvas();
  const updateCanvas = useUpdateCanvas();

  const isIntroVariantShown = useHideIntroVariantSelector();

  return useMemo(
    () => ({
      hideIntroVariant,
      initialiseCanvas,
      updateCanvas,

      isIntroVariantShown,
    }),
    [hideIntroVariant, initialiseCanvas, isIntroVariantShown, updateCanvas],
  );
};
